// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@flip/XDL/Utilities";
import { assignShipToAddressModalStyles } from "@insite/content-library/Widgets/UserSetup/AssignShipToAddressModal";
import { css } from "styled-components";

assignShipToAddressModalStyles.pagination = {
    ...assignShipToAddressModalStyles.pagination,
    selectProps: {
        labelProps: {
            css: css`
                width: auto;
            `,
        },
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
            formInputWrapper: css`
                width: auto;
            `,
        },
    },
};
